document.addEventListener('DOMContentLoaded', () => {
  const slideshows = document.querySelectorAll('slideshow-component');

  slideshows.forEach((slideshow) => {
    // Remove pause on hover listeners if present
    slideshow.removeEventListener('mouseenter', slideshow.pause);
    slideshow.removeEventListener('mouseleave', slideshow.play);

    // If Dawn's script stored them via JS instead of addEventListener, override manually
    if (typeof slideshow.pause === 'function') {
      slideshow.pause = function() {}; // disable pause
    }
    if (typeof slideshow.play === 'function') {
      const originalPlay = slideshow.play.bind(slideshow);
      // restart autoplay immediately
      originalPlay();
    }
  });
});
